module.exports = __webpack_public_path__ + "img/youtube.62e8a3c5.svg";